import header from './header/header'
import footer from './footer/footer'
import center from './center/center'
import shortcuts from './shortcuts/shortcuts'

export default function(o, done){

  var lastInteractionAt = new Date()

  var videoReady = false
  var parts = location.pathname.split('/')
  var roll = parts[parts.length - 2]
  var start = parts[parts.length - 1]
  var projectNumber = roll.split('-')[0]
  var rollNumber = roll.split('-')[1]

  var startSmpte = start.replace(/\-/g, ':')
  var startSec = o.util.smpteToSeconds(startSmpte)

  var rollLabel = o.util.getTranslation(o, 'roll')
  var projectLabel = o.util.getTranslation(o, 'project')
  var rollLabel = o.util.getTranslation(o, 'roll')

  o.data.roll(o, roll, function(rollData){

    document.title = `Open Memory Box | ${rollLabel} | ${projectLabel} ${projectNumber} | ${rollLabel} ${rollNumber}`

    var videoFiles = rollData.roll.files

    var videoFile = videoFiles[MaxResolution].replace('.mp4', '_wm.mp4')
    var videoUrl = o.util.getUrl('watermark',MaxResolution) + videoFile

    var convertRemToPixels = function(rem) {
      return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    }

    var screenRatio = $(document).width() / $(document).height()
    var remPx = convertRemToPixels(1)
    var horizontaOffset = remPx * 0.5

    if(4/3 < screenRatio){
      var w = $(document).height() / 3 * 4
      var b = ($(document).width() - w) / 2
      var horizontaOffset = b
    } 

    if(!o.isTouch){
      var horizontaOffsetTimeline = 1.8 * remPx + horizontaOffset
    } else {
      var horizontaOffsetTimeline = 0
    }

    var horizontaOffsetCenter =  horizontaOffset

    var onTimeUpdate = function(currentTime){

      if(!videoDiv[0].paused){
        var now = new Date()
        if(now - lastInteractionAt > o.autoHideTime){
          headerDiv.hide()
          centerDiv.hide()
          footerDiv.hide()
          if(!o.isTouch){
            timelineDiv.hide()
          }  
        }
      }

      var progress = currentTime / videoDiv[0].duration
      timelineDiv.update(progress)

      footerDiv.update(currentTime)

      if(!videoReady){
        lastInteractionAt = new Date()
        videoReady = true
        shortcuts(footerDiv)
        done(div)
      }

    }

    var onTimeChange = function(progress, currentTime){
      if(!currentTime){
        var currentTime = progress * videoDiv[0].duration
      }
      videoDiv[0].currentTime = currentTime
    }

    var onTogglePlay = function(isPlaying){
      lastInteractionAt = new Date()
      if(isPlaying){
        videoDiv[0].play()
        centerDiv.hide()
        headerDiv.hide()
        footerDiv.hide()
        if(!o.isTouch){
          timelineDiv.hide()
        }
      } else {
        videoDiv[0].pause()
        centerDiv.show()
        headerDiv.show()
        footerDiv.show()
        timelineDiv.show()
      }
    }

    var headerDiv = header(o)
    var footerDiv = footer(o, rollData, onTogglePlay, videoFiles)

    var timelineDiv = o.component.timeline(o, onTimeChange)
    .css({
      position: "absolute",
      left: horizontaOffsetTimeline + 'px',
      right: horizontaOffsetTimeline + 'px',
      zIndex: 2,
    })

    if(!o.isTouch){
      timelineDiv
      .css({
        bottom: '1.6rem',
        boxShadow: '0 0.1rem 0.2rem rgba(0,0,0,0.50)',
      })
    } else {
      timelineDiv
      .css({
        bottom: 0,
      })
    }

    var spacerBottomDiv = 
      $('<div>')
      .css({
        flex: '0 0 auto',
        width: '100%',
      })

    if(!o.isTouch){
      spacerBottomDiv
      .css({
        height: '1.4rem',
      })
    } else {
      spacerBottomDiv
      .css({
        height: '0.5em',
      })
    }

    var centerDiv = center(o, projectNumber, horizontaOffsetCenter)

    var videoDiv = o.component.video(o, videoUrl, onTimeUpdate)
    .css({
      cursor: 'pointer',
      background: 'black',
    })
    .click(function(){
      footerDiv.togglePlay()
    })

    videoDiv[0].muted = true

    var seekVideo = function() {
      videoDiv[0].removeEventListener('canplaythrough', seekVideo)
      if(startSec == 0){startSec = 0.1} // ipad mini hack
      videoDiv[0].currentTime = startSec
      var showVideo = function(){
        videoDiv.show()
        videoDiv[0].play()
        if(videoDiv[0].paused){footerDiv.togglePlay()} // ipad mini hack
        videoDiv[0].removeEventListener('timeupdate', showVideo)
      }
      videoDiv[0].addEventListener('timeupdate', showVideo, false)
    }

    videoDiv[0].addEventListener('canplaythrough', seekVideo, false)
    videoDiv.hide()

    var toggleHideText = function(){
      lastInteractionAt = new Date()
      headerDiv.show()
      footerDiv.show()
      centerDiv.show()
      timelineDiv.show()
    }

    o.body.on('touchstart mousemove', toggleHideText)

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      videoDiv
      .css({
        position: 'fixed',
        objectFit: 'fit',
        overflow: 'hidden',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        cursor: 'pointer',
      }),

      headerDiv
      .css({
        flex: '0 1 auto',
        width: '100%',
        justifyContent: 'center',
        textAlign: 'center',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
        pointerEvents: 'none',
      }),

      centerDiv
      .css({
        flex: '0 0 auto',
        padding: '1rem',
        width: '100%',
        minHeight: 0,
        zIndex: 1,
        pointerEvents: 'none',
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
        pointerEvents: 'none',
      }),

      footerDiv
      .css({
        flex: '0 0 auto',
        width: '100%',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 0,
        zIndex: 1,
      }),

      spacerBottomDiv,

      timelineDiv,

    ])

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/roll/roll.js